import React from 'react';
import BlueButton from '../../buttons/BlueButton';
import logo from '../../../pages/knowhow/logo.jpg';

class Welcome extends React.Component {

    state = {
        url: undefined
    }

    componentDidMount() {
        this.props
            .postOnboarding(this.props.id, this.props.onboarding)
            .then((r) => {
                if (r.success) {
                    this.setState({ url: r.data })
                }
            })
    }

    handleDownload = () => {
        const {url} = this.state;
        const parts = url.split('/');
        const name = parts[parts.length - 1]
        const request = new Request(
            `${url}`,
            {
                method: 'GET'
            },
        );
        fetch(request).then((response) => {
            response.blob().then((blob) => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = `${name}.pdf`;
                a.click();
            });
        });
    }

    render() {
        const { intl } = this.props;
        return (
            <div className="ob_welcome">
                <img alt="logo" className="ob_message_img padding_top_12 padding_bottom_48" src={logo} />
                <span className="ob_end_title">{intl.formatMessage({ id: 'ob_end_title' })}</span>
                <span className="ob_end_subtitle">{intl.formatMessage({ id: 'ob_end_subtitle' })}</span>
                <div className="ob_end_wrap">
                    <span className="ob_end_wrapmessage">{intl.formatMessage({ id: 'ob_end_wrapmessage' })}</span>
                    <button id="ob_end_download" className="ob_download_bt" onClick={this.handleDownload}>
                        {intl.formatMessage({ id: 'ob_end_download' })}
                    </button>
                </div>
                <div className="flex_auto_row width100  c_lipstick center margin_bottom_24 margin_top_24 ">
                    {intl.formatMessage({ id: 'ob_end_message' })}
                </div>
                <div className="flex_auto_row center">
                    <BlueButton id="ob_end_login" className="ob_next" onClick={() => { this.props.history.push('/user/login') }} />
                </div>
            </div>
        );
    }
}

export default Welcome;


// WEBPACK FOOTER //
// ./src/components/complex/onboarding/end.js